import { motion } from "framer-motion";
import { Star } from "lucide-react";
import { Reveal, SplitLines, EASE } from "./Reveal";
import { REVIEWS } from "../data/reviews";

const Stars = () => (
  <div className="flex gap-0.5 text-saffron" aria-label="5 out of 5 stars">
    {[...Array(5)].map((_, i) => <Star key={i} size={13} fill="currentColor" strokeWidth={0} />)}
  </div>
);

export const Reviews = () => (
  <section id="reviews" data-testid="reviews-section" className="relative py-24 lg:py-36">
    <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12">
      <div className="grid lg:grid-cols-12 gap-8 items-end mb-16">
        <div className="lg:col-span-8">
          <Reveal><p className="eyebrow mb-6">03 — Reviews</p></Reveal>
          <h2 className="font-display font-light text-ivory text-[clamp(2.4rem,5.5vw,5rem)] leading-[0.95]">
            <SplitLines inView lines={["What our customers", <span key="a" className="text-saffron italic">say on Google.</span>]} />
          </h2>
        </div>
        <Reveal delay={0.2} className="lg:col-span-4 flex items-center gap-5 lg:justify-end">
          <span className="font-display text-7xl text-saffron leading-none" data-testid="reviews-rating">5.0</span>
          <div><Stars /><p className="text-xs text-ivory/50 mt-2 tracking-wide">{REVIEWS.length} Google reviews</p></div>
        </Reveal>
      </div>

      <div className="columns-1 md:columns-2 xl:columns-3 gap-5 [column-fill:_balance]" data-testid="reviews-grid">
        {REVIEWS.map((r, i) => (
          <motion.blockquote
            key={r.name} data-testid={`review-card-${i}`}
            initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.8, ease: EASE, delay: (i % 3) * 0.1 }}
            className="break-inside-avoid mb-5 bg-[#101010] border border-gold/15 hover:border-saffron/50 transition-colors duration-500 p-7 relative"
          >
            <span className="absolute top-4 right-6 font-display text-6xl text-gold/15 leading-none select-none">”</span>
            <Stars />
            <p className="mt-5 text-ivory/80 font-light leading-relaxed text-[15px]">{r.text}</p>
            <footer className="mt-6 pt-4 border-t border-gold/10 flex items-center justify-between">
              <div>
                <p className="font-display text-lg text-ivory">{r.name}</p>
                <p className="text-[10px] uppercase tracking-[0.25em] text-gold/70 mt-0.5">{r.tag}</p>
              </div>
              <span className="text-[10px] uppercase tracking-[0.2em] text-ivory/40">Google</span>
            </footer>
          </motion.blockquote>
        ))}
      </div>
    </div>
  </section>
);
